function typeEqual(obj, type) {
  return Object.prototype.toString.call(obj) === '[object ' + type + ']';
}

export function isFunction(object) {
  return typeEqual(object, 'Function');
}

export function isString(object) {
  return typeEqual(object, 'String');
}

export function isObject(object) {
  return typeEqual(object, 'Object');
}

export function isJSON(str) {
  if (isString(str)) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }
  return false;
}


// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/fusion/src/util/lang.js